import React, { useState, useEffect } from 'react';
import { aboutData } from '../data';
import { motion } from 'framer-motion';
import { fadeIn } from '../variants';

// Import images
const images = [
  require('../img/hero/1.png'),
  require('../img/hero/2.png'),
  require('../img/hero/3.png'),
];

// Corresponding text content for each image
const heroContent = [
  {
    title: "We're SALIM ARTS Signage Solution Company",
    subtitle: 'The Leading Brand in Signage Industry.',
    btnText: 'Learn More',
    link: '#about',
  },
  {
    title: 'Quick Response to Your Requirement',
    subtitle: 'Always active to serve our clients quickly.',
    btnText: 'Contact Us',
    link: '#contact',
  },
  {
    title: 'Best in Industry',
    subtitle: 'We are the best Signage solution provider in our industry.',
    btnText: 'Our Services',
    link: '#services',
  },
];

const Hero = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  // Update image and text every 5 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 5000); // 5 seconds interval

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, []);

  // Navigate to the previous slide
  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };

  // Navigate to the next slide
  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  return (
    <section className="relative min-h-[80vh] lg:h-[790px] bg-no-repeat bg-center bg-cover ">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-auto  bg-center h-full mx-auto"
        style={{
          backgroundImage: `url(${images[currentIndex]})`,
          backgroundSize: 'cover', // Ensure it covers the section
          backgroundPosition: 'center', // Center the image
          backgroundRepeat: 'no-repeat', // Prevent tiling
        }}
        role="img"
        aria-label={`Hero background ${currentIndex + 1}`}
      />

      {/* Overlay for opacity */}
      <div className="absolute inset-0 bg-black bg-opacity-50" />

      {/* Overlay Content */}
      <motion.div
        variants={fadeIn('down')}
        initial="hidden"
        whileInView="show"
        className="container relative z-10 mx-auto min-h-[70vh] lg:h-full flex items-center justify-center xl:justify-end"
      >
        <div className="text-white text-center lg:text-left lg:max-w-[640px]">
          {/* Dynamic Title */}
          <motion.h1
            className="h1 mb-4 mt-48 lg:mt-0 lg:mr-1"
            key={`title-${currentIndex}`}
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
          >
            {heroContent[currentIndex].title}
          </motion.h1>

          {/* Dynamic Subtitle */}
          <motion.p
            className="text-lg lg:text-2xl mb-8 lg:mb-16 max-w-lg leading-relaxed"
            key={`subtitle-${currentIndex}`}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -10 }}
            transition={{ duration: 0.5 }}
          >
            {heroContent[currentIndex].subtitle}
          </motion.p>

          {/* Dynamic Button */}
          <motion.div
            key={`button-${currentIndex}`}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <a
              href={heroContent[currentIndex].link}
              className="btn btn-sm lg:btn-lg bg-white hover:bg-white text-black px-6 py-3 rounded-md shadow-lg"
            >
              {heroContent[currentIndex].btnText}
              {/* <div className="text-xl inline-block ml-2">→</div> */}
              <div className="text-xl inline-block">{aboutData.btnIcon}</div>
            </a>
          </motion.div>
        </div>
      </motion.div>

      {/* Navigation Arrows */}
      <div className="absolute top-1/2 left-4 transform -translate-y-1/2 z-20">
        <button
          onClick={prevSlide}
          className="text-white bg-opacity-50 p-2 rounded-full hover:bg-opacity-80 focus:outline-none"
        >
          &lt; {/* Left Arrow */}
        </button>
      </div>
      <div className="absolute top-1/2 right-4 transform -translate-y-1/2 z-20">
        <button
          onClick={nextSlide}
          className="text-white bg-opacity-50 p-2 rounded-full hover:bg-opacity-80 focus:outline-none"
        >
          &gt; {/* Right Arrow */}
        </button>
      </div>
    </section>
  );
};

export default Hero;